import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./PubMedSearchIndex.css";
import PubMedDisplayString from "./PubMedDisplayString";
import { isEqual } from 'underscore'

class PubMedRightGenAIAnswer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customWidth: props.customWidth,
      customHeight: props.customHeight,
      displayString: props?.data?.display_string ? props?.data.display_string : [],
      sources: props?.data?.sources ? props.data.sources : [],
      data: props?.data ? props.data : {},
      selectedFinalAnsweringDocSize: props?.selectedFinalAnsweringDocSize,
    };
  }
  componentWillReceiveProps(nextProps) {
    
    if (!isEqual(this.state.data, nextProps.data)) {
      this.setState({
        data: nextProps?.data ? nextProps?.data : {},
        displayString: nextProps?.data?.display_string ? nextProps?.data?.display_string : [],
        sources: nextProps?.data?.sources ? nextProps?.data?.sources : [],
      })
    }
    if (this.state.selectedFinalAnsweringDocSize!== nextProps.selectedFinalAnsweringDocSize) {
        this.setState({selectedFinalAnsweringDocSize:nextProps.selectedFinalAnsweringDocSize
     })
   }
  }

  handleChangedocSize = (e) =>{
    this.setState({
      selectedFinalAnsweringDocSize : e.target.value
    },() => {
      this.props.handleChangeSelectItems(e.target.value)
    })
  }
  
  render() {
    if (this.props.customWidth >= 600 && this.props.customWidth <= 1000) {
      return <></>;
    } else if (this.props.customWidth > 1000) {
      return (
        <div className="pubmed-main-right-answer box mb-4 white-box">
          {this.props.selectedTab === '0' ? 
          <h2 className="semibold text-base m-0">
            Summary (based on top<span style={{paddingLeft:'5px'}} >
            <select 
              style={{outline:"none"}} 
              className="pagination-select-wrapper-dropdown" 
              onChange={e=>this.handleChangedocSize(e)} 
              value={this.state.selectedFinalAnsweringDocSize}
            >    
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
            </select>
          </span> papers)
          </h2> : 
          <h2 className="semibold text-base m-0">
            Summary (based on top 5 papers)
          </h2> }
          <div
            data-testid="synthesis-text"
            className="pubmed-main-right-result-main-answer-section"
          >
            {this.state.displayString.length > 0 ? (
              <p>
                {this.state.displayString?.map((dsitem, dsindex) => {
                  //dsitem.display_ans = dsitem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                  dsitem.display_ans = dsitem.display_ans.replace(/<li><b>/g, "<li>");
                  return (
                    <>
                      <PubMedDisplayString
                        key={`gen-ai-answering-result-main-answer${dsindex}`}
                        displayAns={dsitem.display_ans}
                        sourceNo={dsitem.source_no}
                        pageNumber={dsitem.page_number}
                        sources={this.state.sources}
                        isMultiFiles={false}
                        attachedFiles={[]}
                        eventid={"11"}
                        DisplayString={dsitem.display_string}
                        sessionID={""}
                        Question={""}
                        questionType={""}
                        threadID={""}
                        selectedTab={this.props.selectedTab}
                        resultListRef = {this.props.resultListRef}
                      />
                    </>
                  );
                })}
              </p>
            ) : (
              <p className="semibold text-base m-0">No summary available</p>
            )}
            {/* <div class="absolute top-[5px] right-[15px]">
                        <button class="group relative inline-flex items-center justify-center box-border appearance-none select-none whitespace-nowrap font-normal overflow-hidden tap-highlight-transparent data-[pressed=true]:scale-[0.97] outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 text-tiny gap-2 rounded-small px-0 !gap-0 transition-transform-colors-opacity motion-reduce:transition-none text-secondary min-w-8 w-8 h-8 z-10 aria-expanded:scale-[0.97] aria-expanded:opacity-70 subpixel-antialiased opacity-0 group-hover:opacity-70 transition-opacity duration-300 data-[hover=true]:opacity-100 data-[focus=true]:opacity-100 bg-secondary-300 data-[hover=true]:bg-secondary-400" type="button" aria-label="open LLM action dropdown" data-slot="trigger" id="react-aria5731504829-«r1as»" aria-haspopup="true" aria-expanded="false">
                            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis-vertical" className="svg-inline--fa fa-ellipsis-vertical fa-lg " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 512">
                                <path fill="currentColor" d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"></path>
                            </svg>
                        </button>
                    </div> */}
          </div>
        </div>
      );
    }
  }
}

export default withRouter(PubMedRightGenAIAnswer);
